import { render, staticRenderFns } from "./BusInspectionWorkshopGroupListbefore.vue?vue&type=template&id=72dc7856&scoped=true&"
import script from "./BusInspectionWorkshopGroupListbefore.vue?vue&type=script&lang=js&"
export * from "./BusInspectionWorkshopGroupListbefore.vue?vue&type=script&lang=js&"
import style0 from "./BusInspectionWorkshopGroupListbefore.vue?vue&type=style&index=0&id=72dc7856&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc7856",
  null
  
)

export default component.exports